import React, { Fragment } from 'react';
import CatLinks from './CatLinks';
import Socials from './Socials';
import SearchForm from '../Search/SearchForm';
import { isValid } from '../../utils';
import PropTypes from 'prop-types';

const HeaderScrolling = ({
  HeaderMenuButton,
  HeaderLogo,
  HeaderLogoMark,
  articleHed,
  isMobile,
  social,
  renderedSponsorLogo = null,
  category,
  isCeros,
  tags,
  heroImage,
  hedUrl,
  seo,
}) => {
  let renderedHeader;

  const headerClassName = 'header-scrolling';
  const headerContent2ndChildClass = 'header-content';

  if (isMobile) {
    renderedHeader =
    <Fragment>
      <div className="header-scrolling-wrapper">
        <div className="header-content-start">
          <>{HeaderLogo}</>
          {isValid(category) && <div className={`category-scrolling ${category}`}>{category}</div>}
        </div>
        <div className="header-content-end">
          <>{HeaderMenuButton}</>
          <div className="header-divider"/>
          <SearchForm cssClass="social" canCollapse={true} />
        </div>
      </div>
    </Fragment>
  } else {
    renderedHeader =
      <div className="header-scrolling-wrapper">
        <div className="header-content-start">
          <>{HeaderLogo}</>
          {isValid(articleHed) ? (
            <div className="article-hed-scrolling" dangerouslySetInnerHTML={ { __html: articleHed} }></div>
          ) : (
            <CatLinks isMobile={isMobile} category={category} />
          )}
        </div>
        <div className="header-content-end">
          <>{HeaderMenuButton}</>
          <div className="header-divider"/>
          <SearchForm cssClass="social" canCollapse={true} />
        </div>
      </div>
  }
  
  return (
    <>
      {renderedHeader}
    </>
  );
};

HeaderScrolling.propTypes = {
  HeaderMenuButton: PropTypes.node,
  HeaderLogo: PropTypes.node,
  articleHed: PropTypes.string,
};

export default HeaderScrolling;